import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, OnChanges } from '@angular/core';
import { deliveryTypeOptions } from './delivery-type.constants';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'mode-delivery-type-selector',
  templateUrl: './delivery-type-selector.component.html',
  styleUrls: ['./delivery-type-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeliveryTypeSelectorComponent implements OnChanges {
  @Input() deliveryType = 'email';
  @Input() slackOptionEnabled = false;
  @Output() deliveryTypeChanged = new EventEmitter<string>();
  public options = deliveryTypeOptions;

  ngOnChanges(): void {
    const slackOption = this.options.find((opt) => opt.name === 'slack');
    if (slackOption) {
      slackOption.enabled = this.slackOptionEnabled;
    }
  }
}
